import React from "react";
import AppShell from "@/components/AppShell";
import AutomationsCenter from "@/components/AutomationsCenter";

export default function Automazioni() {
  return (
    <AppShell title="Automazioni" subtitle="Centro delle automazioni Prime Vision. Ricerca, modifica e mantieni le tue impostazioni nel tempo.">
      <AutomationsCenter mode="medico" />
    </AppShell>
  );
}
